import {DomainAncestor, entityConfig} from "../../../core/common/domain/DomainAncestor";
import {observable} from "mobx";
import {ProjectVersion} from "./projectVersionDomain";
import {ProjectVersionMaterial} from "./projectVersionMaterialDomain";
import {LovItem} from "../../../core/metamodel/mdEntity";
import {ID} from "../../../core/metamodel/metaConstant";


@entityConfig()
export default class ProjectVersionLopProfile extends DomainAncestor {

  @observable profileId : number;
  @observable projectVersion : ProjectVersion;
  @observable length : number;
  @observable type : string;
  @observable profileDescription : string;
  @observable frameMaterial1 : LovItem<ProjectVersionMaterial>;
  @observable frameMaterialMass1 : number;
  @observable frameMaterial2 : LovItem<ProjectVersionMaterial>;
  @observable frameMaterialMass2 : number;
  @observable frameMaterial3 : LovItem<ProjectVersionMaterial>;
  @observable frameMaterialMass3 : number;


  constructor(json: any) {
    super(json);
  }

  public getId(): ID {
    return this.profileId;
  }

  public setId(id: ID): void {
    this.profileId = <number>id;
  }

}



// WEBPACK FOOTER //
// ./src/sbtool/domain/project/projectVersionLopProfileDomain.ts